<div class="flex flex-col gap-0.5 pb-2" [formGroup]="form">
  <label *ngIf="label" [for]="id" class="font-medium text-tertiary pt-2 pl-1.5">
    {{ label }}
    <span *ngIf="required && label" class="text-red-600">*</span>
  </label>

  <div class="flex items-center">
    <input
      [class]="getClasses()"
      [id]="id"
      [type]="type"
      class="w-full h-12 rounded-md outline-none p-3 text-base font-normal text-tertiary focus:ring-2 focus:ring-primary"
      [formControlName]="controlName"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [required]="required"
      [class.bg-lightZinc]="readonly"
      [mask]="mask"
      [min]="min"
      [max]="max"
      [thousandSeparator]="thousandSeparator"
      [suffix]="suffix"
      [allowNegativeNumbers]="allowNegativeNumbers"
      [decimalMarker]="decimalMarker"
      (input)="handleInput($event)"
      (blur)="markAsTouched()" />
  </div>

  <div *ngIf="control.invalid && control.touched" class="text-red-600 text-xs">
    <app-errors [formcontrolname]="controlName" [form]="form"></app-errors>
  </div>
</div>
